import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./css/Providers.scss";

// Components

import TitleBox from "../components/TitleBox";
import Footer from "../components/Footer";

// Assets

import HospitalIcon from "../assets/icons/ic-hospital-white.png";
import ClinicIcon from "../assets/icons/ic-clinic-white.png";
import DentalIcon from "../assets/icons/ic-dental-white.png";
import DoctorsIcon from "../assets/icons/ic-dr-white.png";


const Providers = () => {
  const [height, setHeight] = useState(window.innerHeight);
  const [width, setWidth] = useState(window.innerWidth);

  window.addEventListener("resize", function () {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  });

  return (
    <div
      className='providers-container'
      style={{
        height: height - 75,
        width: width,
      }}
    >
      <TitleBox title={"Providers"} />
      <div className='providers-selection'>
        <Link to={"/providers/hospitals"} className='col col-1'>
          <div className='icon'>
            <img src={HospitalIcon} alt='hospital-icon' />
          </div>
          <div className='title'>Hospitals</div>
        </Link>
        <Link to={"/providers/clinics"} className='col col-2'>
          <div className='icon'>
            <img src={ClinicIcon} alt='clinic-icon' />
          </div>
          <div className='title'>Medical Clinic</div>
        </Link>
        <Link to={"/providers/dental"} className='col col-3'>
          <div className='icon'>
            <img src={DentalIcon} alt='dental-icon' />
          </div>
          <div className='title'>Dental Clinics</div>
        </Link>
     
      </div>
      <Footer
        args={{
          height,
          width,
          styles: {
            height: 50,
            width: width,
            position: "absolute",
            bottom: 0,
          },
        }}
      />
    </div>
  );
};

export default Providers;
